import React, { useState } from "react";
import Draggable from "react-draggable";
import { applyUnderline } from "../../../../utils/textUtils";
import CloseButton from "../widgets/CloseButton";

const ParagraphModal = ({ paragraph, setParagraphModalOpen }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleStop = (e, data) => {
    setPosition({ x: data.x, y: data.y });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowY: "auto",
      }}
    >
      <Draggable
        position={position}
        onStop={handleStop}
        handle=".drag-handle"
        cancel=".close-button"
      >
        <div
          className="drag-handle"
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#F6F8FA",
            maxWidth: "800px",
            maxHeight: "70%",
            padding: "30px 50px",
            borderRadius: "5px",
            overflowY: "auto",
            color: "#000",
            gap: "16px",
            cursor: "move",
          }}
        >
          <div>
            <CloseButton onClick={setParagraphModalOpen} />
            <div style={{ fontSize: "20px" }}>전체 본문</div>
          </div>
          <div
            style={{
              borderRadius: "5px",
              padding: "10px",
              fontSize: "18px",
              lineHeight: "2",
              backgroundColor: "#FFF",
            }}
          >
            {paragraph.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {applyUnderline(line)}
                <br />
              </React.Fragment>
            ))}
          </div>
        </div>
      </Draggable>
    </div>
  );
};

export default ParagraphModal;
